module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeremiah Healy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jeremiah Healy (1948–2014) was the creator of the John Cuddy mystery series and the author of several legal thrillers. A graduate of Rutgers College and Harvard Law School, Healy taught at the New England School of Law before becoming a novelist. He published his first novel, "), _c('I', [_vm._v("Blunt Darts")]), _vm._v(", in 1984, introducing John Francis Cuddy, the Boston private eye who would become Healy’s best-known character."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/20Dvd2/cover.jpg?1733151179129",
      "alt": "This image is the cover for the book Right to Die, The John Cuddy Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Right to Die, The John Cuddy Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("While guarding an activist from an assassin, Cuddy makes himself the target")]), _vm._v("To impress his girlfriend and remind himself of his long-neglected athleticism, John Francis Cuddy is training to run the Boston marathon. But the private detective’s fitness regimen goes on the back burner when an old friend approaches him with a dangerous assignment. Euthanasia advocate Maisy Andrus has been receiving death threats, and the police are helpless to protect her. As he tries to keep the crusading lawyer alive, Cuddy realizes that the question isn’t who wants Andrus dead, but who doesn’t. Protecting the right-to-die advocate dredges up painful memories of Cuddy’s wife, who died a slow death from brain cancer. The closer he gets to unmasking the would-be assassin, the more his old wounds open. When the killer starts taking potshots at him, as well as his client, Cuddy’s marathon training will come in handy.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0